<mat-toolbar>Add new question</mat-toolbar>
<div class="Dialog-body">
  <form>
    
    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input matInput type="text" [(ngModel)]="selectedName" [ngModelOptions]="{standalone: true}" matInput placeholder="Name" required>
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <input matInput type="text" [(ngModel)]="selectedDescription" [ngModelOptions]="{standalone: true}" matInput placeholder="Description">
    </mat-form-field>

    <mat-form-field style="width: 400px;padding-top: 1.25em;">
      <mat-select placeholder="{{'Safety Observations'}}"   [(ngModel)]="inputValueSefetyObservation" name="SefetyObservations" [formControl]="sefetyobservation" required>            
        <mat-option [value]="1">Work Area</mat-option>
        <mat-option [value]="2">Office</mat-option>
        <mat-option [value]="3">All</mat-option>
        </mat-select> 
        <mat-error *ngIf="sefetyobservation.invalid">{{getErrorMessage()}}</mat-error>
    </mat-form-field>

      <div class="buttonbelow">
        <button mat-raised-button (click)="DialogClose()">Cancel</button> 
        <button mat-raised-button (click)="CreateQuestion()">Submit</button>
          
      </div>
  </form>

</div>
